/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_DescriptionInputs */

const et_portfolio_description = /** @type {(inputs: Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 Eesti ettevõtte juhtumit: Google TOP 3 90 päevaga, 3,3x SEO liikluse kasv, 10x orgaaniline liiklus. Vaata tegelikke veebidisaini ja SEO tulemusi.`)
};

const en_portfolio_description = /** @type {(inputs: Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 business case studies: Google Top 3 in 90 days, 3.3x SEO traffic growth, 10x organic traffic. Real web design and SEO results from Estonian businesses.`)
};

/**
* | output |
* | --- |
* | "8 business case studies: Google Top 3 in 90 days, 3.3x SEO traffic growth, 10x organic traffic. Real web design and SEO results from Estonian businesses." |
*
* @param {Portfolio_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_description = /** @type {((inputs?: Portfolio_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_description(inputs)
	return en_portfolio_description(inputs)
});